import React, { useMemo } from 'react';

import { useParams } from 'react-router-dom';

import { Checkbox } from 'components';
import { baseFilters } from 'constants/table';
import translations from 'constants/translations';

import GrayText from './GrayText';
import ModalSection from './Section';

type FilterMapType = [string, string[]]

export default function CheckBoxFilters({ register }) {
  const { content } = useParams<GeneralRoute>();
  const filterMap = useMemo(() => Object.entries(baseFilters[content].checkbox), [content]);

  const Options = ({ item, index, group }) => (
    <Checkbox
      {...register(`${group}.${index}`)}
      value={item}
      pb={1}>
      {item}
    </Checkbox>
  );

  const OptionGroups = ({ group, value }) => (
    <>
      <GrayText
        pb={1}
        variant="smallBold">
        {translations[group]}
      </GrayText>
      {value.map((label, index) => (
        <Options
          item={label}
          index={index}
          group={group}
          key={`${label}-${index}`}
        />
      ))}
    </>
  );

  return (
    <ModalSection
      py={4}>
      {filterMap.map(([key, value]: FilterMapType) => (
        <OptionGroups
          key={`${key}-${value}`}
          group={key}
          value={value}
        />
      ))}
    </ModalSection>
  );
}
